import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./store";
const App = React.lazy(() => import('./App'));

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <React.Suspense fallback={''}>
        <App />
      </React.Suspense>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
